import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import TooltipIcon from "PFComponents/tooltip_icon/tooltip_icon";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

import css from "../../side_panel_rows.module.scss";
import { ShowAllBookingsAction } from "../row_menu/row_menu_show_all_bookings";

interface SidePanelRowActionsProps {
  className?: string;
  showAllBookingsAction: ShowAllBookingsAction;
}

export const SidePanelRowActions = ({
  className,
  showAllBookingsAction
}: SidePanelRowActionsProps): JSX.Element | null => {
  const { t } = useTranslation("bookingModule");
  const { isEnabled, onClick } = showAllBookingsAction;
  if (!isEnabled) {
    return null;
  }
  return (
    <div className={className}>
      <TooltipIcon
        content={t("projects.hideAllBookingsTooltip")}
        IconComponent={() => (
          <Button kind="blank" onClick={onClick} className={css.showAllBookingsIcon}>
            <Icon name="shown" />
          </Button>
        )}
      />
    </div>
  );
};
